<template>
  <component v-if="headerComponent" :is="headerComponent" />

  <router-view v-if="!isStoreRoute" />

  <component v-if="showFooter && footerComponent" :is="footerComponent" />
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  components: {
    
  },
  computed: {
    isStoreRoute() {
      return this.$route.path.includes('my-store');
    },
    isCheckoutRoute() {
      return this.$route.path.includes('checkout');
    },
    showFooter() {
      return !this.$route.path.includes('/hide-menu');
    },
    headerComponent() {
        if (this.isStoreRoute) {
          return defineAsyncComponent(() =>
            import('./Components/HeaderStore.vue')
          );
        }

        else if (this.isCheckoutRoute) {
          return defineAsyncComponent(() =>
            import('./Components/HeaderCheckout.vue')
          );
        }

      return defineAsyncComponent(() =>
        import('./Components/Header.vue')
      );
    },
    footerComponent() {
        if (!this.isStoreRoute && !this.isCheckoutRoute) {
          return defineAsyncComponent(() =>
            import('./Components/Footer.vue')
          );
        }

      
    }
  }
};
</script>